import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchBlogs } from '../lib/api';

// Site-wide crawl path to the newest AI blogs (they reach /sitemap.xml only on the next build).
export const FooterLatestArticles = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchBlogs()
      .then((data) => setPosts((data || []).slice(0, 5)))
      .catch(() => setPosts([]));
  }, []);

  return (
    <div data-testid="footer-latest-articles">
      <h4 className="font-display text-sm uppercase tracking-[0.14em] text-white/50 font-medium mb-4">
        Latest articles
      </h4>
      <ul className="space-y-3">
        {posts.map((p) => (
          <li key={p.slug}>
            <Link
              to={`/insights/${p.slug}`}
              data-testid={`footer-article-link-${p.slug}`}
              className="text-white/70 hover:text-amber-400 transition-colors text-sm line-clamp-2"
            >
              {p.title}
            </Link>
          </li>
        ))}
        <li>
          <Link to="/insights" className="text-amber-400/90 hover:text-amber-300 transition-colors text-sm">
            All articles &rarr;
          </Link>
        </li>
      </ul>
    </div>
  );
};
